import blog_2021_01_31 from './2021-01-31'

export default [
    blog_2021_01_31,
]